function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.411,
    y1: 0.0000436869,
    x2: 0.5927,
    y2: 0.0000436869,
    gradientTransform: "matrix(267.753898,-272.430831,272.430831,267.753898,-96.485207,174.810488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.745098%,0.392157%,20.784314%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(38.039216%,17.647059%,31.372549%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 19.304688 10.261719 L 56.695312 10.261719 C 61.621094 10.261719 65.617188 14.257812 65.617188 19.183594 L 65.617188 56.816406 C 65.617188 61.742188 61.621094 65.738281 56.695312 65.738281 L 19.304688 65.738281 C 14.378906 65.738281 10.382812 61.742188 10.382812 56.816406 L 10.382812 19.183594 C 10.382812 14.257812 14.363281 10.261719 19.304688 10.261719 Z M 19.304688 10.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.410156 34.140625 C 39.824219 34.140625 40.886719 33.835938 41.617188 33.210938 C 42.347656 32.605469 42.710938 31.691406 42.710938 30.492188 C 42.710938 29.304688 42.347656 28.410156 41.617188 27.800781 C 40.886719 27.175781 39.824219 26.859375 38.410156 26.859375 L 33.457031 26.859375 L 33.457031 34.140625 L 38.410156 34.140625 M 38.714844 49.171875 C 40.507812 49.171875 41.859375 48.792969 42.757812 48.046875 C 43.667969 47.300781 44.125 46.164062 44.125 44.640625 C 44.125 43.152344 43.667969 42.042969 42.773438 41.296875 C 41.875 40.554688 40.523438 40.171875 38.699219 40.171875 L 33.441406 40.171875 L 33.441406 49.171875 L 38.714844 49.171875 M 47.042969 36.8125 C 48.960938 37.363281 50.449219 38.378906 51.511719 39.871094 C 52.5625 41.359375 53.09375 43.183594 53.09375 45.339844 C 53.09375 48.65625 51.96875 51.132812 49.703125 52.757812 C 47.4375 54.386719 44.003906 55.207031 39.382812 55.207031 L 24.519531 55.207031 L 24.519531 20.839844 L 37.953125 20.839844 C 42.773438 20.839844 46.269531 21.554688 48.425781 22.996094 C 50.601562 24.441406 51.679688 26.753906 51.679688 29.929688 C 51.679688 31.601562 51.285156 33.03125 50.496094 34.214844 C 49.703125 35.386719 48.546875 36.253906 47.042969 36.8125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostrap);
export default __webpack_public_path__ + "static/media/boostrap.be4ef0e6a251b1abe4f5f76f5742a09e.svg";
export { ForwardRef as ReactComponent };